// Configuração da URL base da API
const API_BASE_URL =
  process.env.REACT_APP_API_URL || `${window.location.origin}/api`;

export default API_BASE_URL;
